// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import facets from './facets';
import hasSearchResults from '../../shared/reducers/has-search-results';
import rejectedReason from './rejected-reason';
import reportsAccordion from './reports-accordion';
import searchByDropDown from '../../shared/reducers/search-dropdown';
import searchFilters from './search-filters';
import searchQueryString from '../../shared/reducers/search-query-string';
import transfers from './transfers';

export default {
    transferApprovals: combineReducers({
        busyCounter,
        facets,
        hasSearchResults,
        rejectedReason,
        reportsAccordion,
        searchByDropDown,
        searchFilters,
        searchQueryString,
        transfers

    })
};



// WEBPACK FOOTER //
// ./src/product/transfers/reducers/index.js